import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate } from "react-router-dom";
import MobileSideNavbar from "../../Components/MobileSideNavbar/MobileSideNavbar";
import SideNavbar from "../../Components/SideNavbar/SideNavbar";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import "./Admin.css";
import { MdKeyboardArrowUp } from "react-icons/md";
import {
  GetDropDownApi,
  GetSingleEmployeeData,
} from "../../Services/CommonApis";
import { arrayToOptions } from "../../Services/GeneralFunctions";
import { notification } from "antd";

export default function Admin() {
  const [api, contextHolder] = notification.useNotification();

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const [dropDowns, setDropDowns] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const navigate = useNavigate(null);

  const getAllDropDowns = async () => {
    try {
      const data = await GetDropDownApi("");
      console.log(data.data.data);
      if (data.data.success) {
        let optionsArray = {};
        data.data.data.map(
          (val) => (optionsArray[val?.field] = arrayToOptions(val?.value))
        );
        setDropDowns(optionsArray);
        console.log(optionsArray);
      } else {
        console.log("error");
        api.error({
          message: "Error while fetching dropdowns",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      console.log("error");

      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  console.log(dropDowns);

  const getProfileData = async () => {
    try {
      const data = await GetSingleEmployeeData(
        sessionStorage.getItem("userId")
      );

      if (data.data.success) {
        setProfileData(data.data.data);
      } else {
        api.error({
          message: "Error while Fetching Profile Details",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to Check your Internet Connection.",
        placement: "top",
      });
    }
  };

  useEffect(() => {
    // navigate('/admin/employees-manager');
    // navigate('/admin/geo-tag/employees', { state: {openedKeys: 'geo-tag'} });
    // navigate("/admin/employees-manager");
    getAllDropDowns();
    getProfileData();
  }, []);

  useEffect(() => {
    isLoggedIn();
  });

  const isLoggedIn = () => {
    if (sessionStorage.getItem("isLoggedIn") === "true") {
      if (sessionStorage.getItem("userType") !== "admin") {
        navigate(-1);
      }
    } else {
      navigate("/auth");
    }
  };

  return (
    <>
      {contextHolder}
      <Helmet>
        <style>{`body {
        background: #F4F4F9;
      
        }`}</style>
      </Helmet>

      <MobileSideNavbar
        type="admin"
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
      />
      <SideNavbar type="admin" />

      <div id="dashboard-body" style={{ margin: "0px 0px 0px 256px" }}>
        <TopNavbar type="admin" setIsNavbarOpen={setIsNavbarOpen} />

        <div className="dashboard-subbody mt-3">
          <Outlet context={{ dropDowns, profileData }} />
          <div
            className="text-center go-to-top"
            onClick={() => window.scrollTo(0, 0)}
          >
            <MdKeyboardArrowUp style={{ fontSize: "40px" }} />
          </div>
        </div>
      </div>
    </>
  );
}
